module.exports = __webpack_public_path__ + "static/img/icon_08.aac92942.png";